/* @flow */
import React from 'react';
import PropTypes from 'prop-types';
import type { Node } from 'react';

import './Dropdown.scss';

/**
 * Common Moo style Dropdown that can be extended
 */

type Props = {
  active: boolean,
  position: string,
  arrowHighlight: boolean,
  children?: Node,
};

const dropdownPositions = [
  'top-left',
  'top-center',
  'top-right',
  'right-top',
  'right-center',
  'right-bottom',
  'bottom-right',
  'bottom-center',
  'bottom-left',
  'left-bottom',
  'left-center',
  'left-top',
];

const DropdownComponent = (props: Props) => {
  const { active, position, arrowHighlight, children } = props;

  const activeClass = active ? 'dropdown-component--active' : '';
  const arrowHighlightClass = arrowHighlight ? '--highlight' : '';

  return (
    <div className={`dropdown-component dropdown-component__position--${position} ${activeClass}`}>
      <div
        className={`dropdown-component__arrow dropdown-component__arrow--${position} dropdown-component__arrow--${position}${arrowHighlightClass}`}
      />
      {children}
    </div>
  );
};

DropdownComponent.displayName = 'Dropdown';

DropdownComponent.propTypes = {
  active: PropTypes.bool,
  position: PropTypes.oneOf(dropdownPositions).isRequired,
  arrowHighlight: PropTypes.bool,
  children: PropTypes.node,
};

DropdownComponent.defaultProps = {
  active: false,
  position: 'bottom-center',
  arrowHighlight: false,
  children: null,
};

export default DropdownComponent;
